<div class="form-container service-form ms-large-t" #formContainer>
  <!-- While loading the profile-->
  <fin-loader *ngIf="!reactiveForm" [type]="LoaderType.INLINE"></fin-loader>
  <!-- Initial form state -->
  <form
    *ngIf="(reactiveForm && formStatus === FormStatus.INITIAL) || formStatus === FormStatus.ERROR"
    [formGroup]="reactiveForm"
    [finFormErrorFocus]="reactiveForm"
    (ngSubmit)="onSubmit()"
  >
    <!-- Error notification -->
    <fcom-notification
      *ngIf="formStatus === FormStatus.ERROR"
      class="mr-medium-b"
      role="alert"
      [layout]="NotificationLayout.BLOCK"
      [theme]="NotificationTheme.ALERT"
    >
      {{ 'SERVICE_FORMS.serviceForms.error.title' | finLocalization }}
    </fcom-notification>

    <div class="flex flex--row flex--wrap form-subgroup ms-xlarge-b">
      <fcom-radio-item-group
        [options]="[{ value: RefundFormPurchaseChannels.FINNAIR }, { value: RefundFormPurchaseChannels.OTHER }]"
        data-testid="purchase-channel"
        [parentForm]="reactiveForm"
        [controlName]="'purchaseChannel'"
        [isSensitive]="true"
        [translationPrefix]="'SERVICE_FORMS.serviceForms.refundForm.purchaseChannel'"
      >
      </fcom-radio-item-group>
    </div>
    <fcom-notification
      *ngIf="selectedPurchaseChannel === RefundFormPurchaseChannels.OTHER"
      class="mr-medium-y purchase-channel-error"
      [layout]="NotificationLayout.BLOCK"
      [theme]="NotificationTheme.ALERT"
    >
      {{ 'SERVICE_FORMS.serviceForms.refundForm.contactSeller' | finLocalization }}
    </fcom-notification>

    <div
      *ngIf="selectedPurchaseChannel === RefundFormPurchaseChannels.FINNAIR"
      class="flex flex--row flex--wrap form-subgroup refund-type ms-xlarge-b"
    >
      <fcom-radio-item-group
        data-testid="refund-types"
        [options]="availableRefundTypes"
        [parentForm]="reactiveForm"
        [controlName]="'refundType'"
        [isSensitive]="true"
        [translationPrefix]="'SERVICE_FORMS.serviceForms.refundForm.refundType'"
      >
      </fcom-radio-item-group>
    </div>

    <div
      *ngIf="reactiveForm.controls.refundType.value"
      class="flex flex--row flex--wrap form-subgroup refund-reason ms-xlarge-b"
    >
      <fcom-radio-item-group
        data-testid="refund-reasons"
        [options]="
          reactiveForm.controls.refundType.value === RefundTypes.EXTRAS ? refundReasonsExtras : refundReasonsFlight
        "
        [parentForm]="reactiveForm"
        [controlName]="'refundReason'"
        [isSensitive]="true"
        [translationPrefix]="'SERVICE_FORMS.serviceForms.refundForm.refundReason'"
      >
      </fcom-radio-item-group>
    </div>

    <ng-container *ngIf="selectedRefundReason">
      <span class="block font-body-1 nordic-blue-900-text mr-medium-y">{{
        'SERVICE_FORMS.serviceForms.mandatoryFields' | finLocalization
      }}</span>

      <h3>{{ 'SERVICE_FORMS.serviceForms.refundForm.contactDetailsTitle' | finLocalization }}</h3>
      <div class="flex flex--row flex--wrap form-subgroup contact-details" data-testid="contact-details">
        <fcom-text-input
          [parentForm]="reactiveForm"
          [controlName]="'phoneNumber'"
          [placeHolder]="'SERVICE_FORMS.serviceForms.fields.phoneNumber.placeholder'"
          [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.phoneNumber'"
        ></fcom-text-input>
        <fcom-text-input
          [parentForm]="reactiveForm"
          [controlName]="'email'"
          [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.email'"
        ></fcom-text-input>
      </div>

      <h3>{{ 'SERVICE_FORMS.serviceForms.refundForm.bookingDetailsTitle' | finLocalization }}</h3>
      <div class="flex flex--row flex--wrap form-subgroup" data-testid="booking-details">
        <fcom-text-input
          [parentForm]="reactiveForm"
          [controlName]="'reservationNumber'"
          [placeHolder]="'SERVICE_FORMS.serviceForms.fields.reservationNumber.placeholder'"
          [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.reservationNumber'"
        ></fcom-text-input>
        <fin-datepicker
          *ngIf="selectedRefundReason !== RefundFormRefundReasons.CANCELLED_WITHIN_24_HOURS"
          [parentForm]="reactiveForm"
          [controlName]="'flightDate'"
          [placeHolder]="'SERVICE_FORMS.serviceForms.fields.flightDate.placeholder'"
          [minDate]="minDateFlight"
          [maxDate]="maxDateFlight"
          class="flight-date"
          [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.flightDate'"
          [theme]="DatepickerTheme.WEB_2"
        ></fin-datepicker>
        <fin-datepicker
          *ngIf="selectedRefundReason === RefundFormRefundReasons.CANCELLED_WITHIN_24_HOURS"
          [parentForm]="reactiveForm"
          [controlName]="'bookingDate'"
          [placeHolder]="'SERVICE_FORMS.serviceForms.fields.bookingDate.placeholder'"
          [minDate]="minDateBooking"
          [maxDate]="maxDateBooking"
          class="booking-date"
          [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.bookingDate'"
          [theme]="DatepickerTheme.WEB_2"
        ></fin-datepicker>
        <fin-datepicker
          *ngIf="selectedRefundReason === RefundFormRefundReasons.CANCELLED_WITHIN_24_HOURS"
          [parentForm]="reactiveForm"
          [controlName]="'cancellationDate'"
          [placeHolder]="'SERVICE_FORMS.serviceForms.fields.cancellationDate.placeholder'"
          [minDate]="minDateBooking"
          [maxDate]="maxDateBooking"
          class="cancellation-date"
          [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.cancellationDate'"
          [theme]="DatepickerTheme.WEB_2"
        ></fin-datepicker>
      </div>

      <h3>{{ 'SERVICE_FORMS.serviceForms.refundForm.passengerDetailsTitle' | finLocalization }}</h3>
      <div class="form-subgroup passenger-details" data-testid="passenger-details">
        <fin-form-array
          [parentForm]="reactiveForm"
          [controlName]="'passengers'"
          [formGroupConfig]="passengerFormGroupConfig"
          [translationPrefix]="'SERVICE_FORMS.serviceForms.refundForm.fields.passengers'"
          [displayLabels]="true"
          [minGroups]="1"
        >
          <ng-template let-parentPassenger="parentFormGroup" let-index="index">
            <div class="flex flex--row flex--wrap form-subgroup">
              <fcom-text-input
                [parentForm]="parentPassenger"
                [controlName]="'firstname'"
                [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.firstName'"
                [id]="'passenger_' + (index + 1) + '_firstname'"
              ></fcom-text-input>
              <fcom-text-input
                [parentForm]="parentPassenger"
                [controlName]="'lastname'"
                [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.lastName'"
                [id]="'passenger_' + (index + 1) + '_lastname'"
              ></fcom-text-input>
              <fcom-text-input
                [parentForm]="parentPassenger"
                [controlName]="'finnairPlusNumber'"
                [placeHolder]="'SERVICE_FORMS.serviceForms.fields.cardNumber.placeholder'"
                [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.cardNumber'"
                [id]="'passenger_' + (index + 1) + '_finnairPlusNumber'"
              ></fcom-text-input>
              <fcom-text-input
                *ngIf="requestContainsFlight"
                [parentForm]="parentPassenger"
                class="passenger-ticket-number"
                [controlName]="'ticketNumber'"
                [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.ticketNumber'"
                [placeHolder]="'SERVICE_FORMS.serviceForms.fields.ticketNumber.placeHolder'"
                [id]="'passenger_' + (index + 1) + '_ticketNumber'"
              ></fcom-text-input>
            </div>

            <div
              *ngIf="requestContainsExtras"
              class="flex flex--row flex--wrap form-subgroup"
              class="travel-extra-details"
            >
              <fin-form-array
                [parentForm]="parentPassenger"
                [controlName]="'travelExtras'"
                [formGroupConfig]="travelExtrasFormGroupConfig"
                [translationPrefix]="'SERVICE_FORMS.serviceForms.refundForm.fields.travelExtras'"
                [displayLabels]="true"
                [isNestedArray]="true"
                [minGroups]="selectedRefundType === RefundTypes.EXTRAS ? 1 : 0"
              >
                <ng-template let-parentTravelExtra="parentFormGroup" let-index2="index">
                  <div class="flex flex--row flex--wrap form-subgroup">
                    <fcom-text-input
                      [parentForm]="parentTravelExtra"
                      [controlName]="'emdNumber'"
                      [translationPrefix]="'SERVICE_FORMS.serviceForms.refundForm.fields.emdNumber'"
                      [placeHolder]="'SERVICE_FORMS.serviceForms.refundForm.fields.emdNumber.placeholder'"
                      [id]="'extra_' + (index + 1) + '_' + (index2 + 1) + '_emdNumber'"
                    ></fcom-text-input>
                    <fin-select-input
                      [parentForm]="parentTravelExtra"
                      [controlName]="'refundItemType'"
                      [options]="travelExtraTypeOptions$ | async"
                      [translationPrefix]="'SERVICE_FORMS.serviceForms.refundForm.fields.travelExtraType'"
                    ></fin-select-input>
                  </div>
                </ng-template>
              </fin-form-array>
            </div>
          </ng-template>
        </fin-form-array>
      </div>

      <h3>{{ 'SERVICE_FORMS.serviceForms.fields.refundForm.paymentDetailsTitle' | finLocalization }}</h3>

      <ng-container *ngIf="selectedPaymentMethod === RefundPaymentMethods.MONEY_BACK">
        <span class="block font-body-1 mr-xsmall-t mr-xsmall-b nordic-blue-900-text">
          {{ 'SERVICE_FORMS.serviceForms.refundForm.paymentDetailsNote' | finLocalization }}
        </span>

        <span class="block font-body-1 mr-xsmall-t mr-xsmall-b nordic-blue-900-text">
          {{ 'SERVICE_FORMS.serviceForms.refundForm.paymentDetailsNotePartTwo' | finLocalization }}
        </span>
        <div class="flex flex--row flex--wrap form-subgroup payment-type ms-xlarge-b" data-testid="payment-types">
          <fcom-radio-item-group
            [options]="[{ value: RefundPaymentTypes.ONLINE_BANK }, { value: RefundPaymentTypes.OTHER }]"
            [parentForm]="reactiveForm"
            [controlName]="'paymentType'"
            [isSensitive]="true"
            [translationPrefix]="'SERVICE_FORMS.serviceForms.refundForm.paymentType'"
          >
          </fcom-radio-item-group>
        </div>
      </ng-container>

      <ng-container *ngIf="selectedPaymentType === RefundPaymentTypes.ONLINE_BANK">
        <div class="flex flex--row flex--wrap form-subgroup bank-details">
          <fin-select-input
            [parentForm]="reactiveForm"
            [controlName]="'country'"
            [options]="countries"
            [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.bankCountry'"
          ></fin-select-input>
          <fcom-text-input
            *ngIf="reactiveForm.get('iban').enabled"
            [parentForm]="reactiveForm"
            [controlName]="'iban'"
            (change)="stripSpaces('iban')"
            class="bank-details-iban"
            [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.iban'"
          ></fcom-text-input>
          <fcom-text-input
            *ngIf="reactiveForm.get('accountNumber').enabled"
            [parentForm]="reactiveForm"
            [controlName]="'accountNumber'"
            class="bank-details-account-number"
            [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.accountNumber'"
          ></fcom-text-input>
          <fcom-text-input
            *ngIf="reactiveForm.get('accountHolder').enabled"
            [parentForm]="reactiveForm"
            [controlName]="'accountHolder'"
            [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.accountHolder'"
          ></fcom-text-input>
          <fcom-text-input
            *ngIf="reactiveForm.get('accountHolderAddress').enabled"
            [parentForm]="reactiveForm"
            [controlName]="'accountHolderAddress'"
            [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.accountHolderAddress'"
          ></fcom-text-input>
          <fcom-text-input
            *ngIf="reactiveForm.get('bic').enabled"
            [parentForm]="reactiveForm"
            [controlName]="'bic'"
            (change)="stripSpaces('bic')"
            [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.bic'"
          ></fcom-text-input>
          <fcom-text-input
            *ngIf="reactiveForm.get('bankName').enabled"
            [parentForm]="reactiveForm"
            [controlName]="'bankName'"
            [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.bankPlainName'"
          ></fcom-text-input>
          <fcom-text-input
            *ngIf="reactiveForm.get('bankAddress').enabled"
            [parentForm]="reactiveForm"
            [controlName]="'bankAddress'"
            [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.bankAddress'"
          ></fcom-text-input>
          <fcom-text-input
            *ngIf="reactiveForm.get('ncc').enabled"
            [parentForm]="reactiveForm"
            [controlName]="'ncc'"
            [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.ncc'"
          ></fcom-text-input>
          <fcom-text-input
            *ngIf="reactiveForm.get('ifsc').enabled"
            [parentForm]="reactiveForm"
            [controlName]="'ifsc'"
            (change)="stripSpaces('ifsc')"
            [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.ifsc'"
          ></fcom-text-input>
          <fcom-text-input
            *ngIf="reactiveForm.get('bik').enabled"
            [parentForm]="reactiveForm"
            [controlName]="'bik'"
            (change)="stripSpaces('bik')"
            [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.bik'"
          ></fcom-text-input>
          <fcom-text-input
            *ngIf="reactiveForm.get('correspondentBankData').enabled"
            [parentForm]="reactiveForm"
            [controlName]="'correspondentBankData'"
            [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.correspondentBankData'"
          ></fcom-text-input>
          <fcom-text-input
            *ngIf="reactiveForm.get('kpp').enabled"
            [parentForm]="reactiveForm"
            [controlName]="'kpp'"
            (change)="stripSpaces('kpp')"
            [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.kpp'"
          ></fcom-text-input>
          <fcom-text-input
            *ngIf="reactiveForm.get('inn').enabled"
            [parentForm]="reactiveForm"
            [controlName]="'inn'"
            (change)="stripSpaces('inn')"
            [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.inn'"
          ></fcom-text-input>
          <fcom-text-input
            *ngIf="reactiveForm.get('patronymicName').enabled"
            [parentForm]="reactiveForm"
            [controlName]="'patronymicName'"
            [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.patronymicName'"
          ></fcom-text-input>
        </div>
      </ng-container>

      <h3>{{ 'SERVICE_FORMS.serviceForms.fields.additionalInformation.label' | finLocalization }}</h3>
      <span class="block font-body-1 mr-xsmall-t mr-xsmall-b nordic-blue-900-text">
        {{ 'SERVICE_FORMS.serviceForms.refundForm.additionalInformationNote' | finLocalization }}
      </span>
      <div class="flex flex--row flex--wrap form-subgroup">
        <fcom-text-input
          #additionalInformation
          data-testid="additional-information"
          [parentForm]="reactiveForm"
          [controlName]="'additionalInformation'"
          [isSensitive]="true"
          [type]="TextInputType.TEXTAREA"
          [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.additionalInformation'"
          [characterLimit]="additionalInformationCharacterLimit"
          [characterCount]="characterCount"
        ></fcom-text-input>
      </div>
    </ng-container>

    <div class="ps-small-t align-right">
      <fcom-button
        [type]="ButtonType.SUBMIT"
        [text]="'SERVICE_FORMS.serviceForms.submit' | finLocalization"
      ></fcom-button>
    </div>
  </form>
  <!-- While sending -->
  <div *ngIf="formStatus === FormStatus.LOADING" class="relative loader align-center" role="status">
    <p>{{ 'SERVICE_FORMS.serviceForms.loading.title' | finLocalization }}</p>
    <fin-loader [type]="LoaderType.INLINE"></fin-loader>
  </div>
  <!-- Success notification -->
  <fcom-notification
    *ngIf="formStatus === FormStatus.COMPLETE"
    class="success-message mr-medium-y"
    role="status"
    [layout]="NotificationLayout.BLOCK"
    [theme]="NotificationTheme.SUCCESS"
  >
    {{ 'SERVICE_FORMS.serviceForms.success.title' | finLocalization }}
  </fcom-notification>
</div>
